import React, { useRef } from 'react';
import { BsFeather, BsPlayFill, BsPauseFill, BsSkipStartFill, BsSkipEndFill } from 'react-icons/bs';
import { useDisableMapEvents } from '../hooks/useDisableMapEvents';

export default function PlumeTimeControls({
  plumeTime,
  isPlaying,
  plumePanelCollapsed,
  stopPlayback,
  startPlayback,
  showFrame,
  plumeFrames,
  currentFrameIndex
}) {
  const ref = useRef(null);
  useDisableMapEvents(ref);

  return (
    <div
      ref={ref}
      className="map-card"
      style={{
        // bottom: 10,
        // right: plumePanelCollapsed ? 10 : 410,
        padding: '8px 14px',
        display: 'flex',
        alignItems: 'center',
        gap: 14,
        fontWeight: 600
      }}
    >

      <span>{plumeTime}</span>

      <BsSkipStartFill
        size={14}
        title="Previous frame"
        style={{ cursor: 'pointer' }}
        onClick={() => {
          stopPlayback();
          const n = plumeFrames.current.length;
          const prev = (currentFrameIndex.current - 1 + n) % n;
          showFrame(prev);
        }}
      />

      {isPlaying ? (
        <BsPauseFill
          size={14}
          title="Pause animation"
          style={{ cursor: 'pointer' }}
          onClick={stopPlayback}
        />
      ) : (
        <BsPlayFill
          size={14}
          title="Resume animation"
          style={{ cursor: 'pointer' }}
          onClick={() => startPlayback(3000)}
        />
      )}

      <BsSkipEndFill
        size={14}
        title="Next frame"
        style={{ cursor: 'pointer' }}
        onClick={() => {
          stopPlayback();
          const n = plumeFrames.current.length;
          const next = (currentFrameIndex.current + 1) % n;
          showFrame(next);
        }}
      />
    </div>
  );
}
